import React from 'react';
import './Biodata.scss';
import bdbanner from '../assets/img/biodata-banner.png';
function Bioheader() {
  return (<>
    
    <div className="bg-white p-3 mt-4 mb-4 rounded-lg shadow-sm top_bio_heading">
      <h1>Free Marriage Biodata Maker – Create Wedding Biodata Online</h1>
      <p>Create your marriage biodata online in minutes.
<strong>Fill details</strong>, <strong>choose a template</strong>, and <strong>download your biodata</strong> in PDF or image format.
<strong>No registration required.</strong></p>
  </div></>
  )
}

export default Bioheader
